import { toast, loading } from '@/shared/utils/UIHelper'

// TODO: não alterar aqui, favor ir em actionsForm.js e alterar lá. Estou migrando aos poucos os lugares que usam esta funcçõa aqui.
// DEPRECATED
function advancedOnException (error, lang) {
  loading.pop()

  if (error.message === 'Unauthorized' || error.message === 'ExpiredToken' || error.message === 'Cannot read properties of undefined (reading \'status\')') {
    toast.error(lang.Common.SessionEnded)
    return
  }
  if (error.data) {
    if (error.data.errors) {
      if (error.data.errors[0].message === 'could not execute statement; SQL [n/a]; constraint [pessoa.uk_document]; nested exception is org.hibernate.exception.ConstraintViolationException: could not execute statement') {
        toast.error('Documento já cadastrado')
        return
      }
      if (error.data.errors[0].identification === 'Usuário já existe') {
        toast.error('Nome de Usuário já cadastrado')
        return
      }
      if (error.data.errors[0].message === 'Senha inválida') {
        toast.error('Senha inválida')
        return
      }
      if (error.data.errors[0].identification) {
        toast.error(error.data.errors[0].identification)
        return
      }
      if (error.data.errors[0].code) {
        toast.error(error.data.errors[0].message)
        return
      }
    } else {
      if (error.data && typeof error.data === 'object') {
        Object.entries(error.data).forEach(([field, messages]) => {
          toast.error(messages.join('\r\n'), 'Erro:')
        })
      }
      return
    }
  }

  if (error instanceof CustomError) {
    toast[error.level](error.message, error.title)
    return
  }

  toast.error(lang.Common.MicroserviceUnavailable)
}

/**
 * Builds a string to be used as filter against the js repository files. Returns `String`
 * @param filterPairs object/dictionary, with key and value to be separated by =. Type `Object[]`
 */
function buildParamFilters (filterPairs) {
  let keyValueStringfiedPairs = []
  let keys = Object.keys(filterPairs)
  let values = Object.values(filterPairs)

  if (filterPairs) {
    for (let i = 0; i < keys.length; i++) {
      let temp1 = `${keys[i]}=${values[i]}`
      keyValueStringfiedPairs.push(temp1)
    }
  }
  let paramString = keyValueStringfiedPairs.join('&')
  return paramString
}

export { advancedOnException, buildParamFilters }



// WEBPACK FOOTER //
// ./src/components/tools/Utils.js